import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import {
  RESET_CARE_LANGUAGE_STATE,
  RESET_PARSE_PREFERENCE_DATA,
  SET_AVAILABLE_CARE_LANGUAGES,
  SET_PARENT_INITIATED_IN_PERSON_S4C_PREFERENCE_CHECKED,
  SET_PARENT_INITIATED_IN_PERSON_TEEN_S4C_PREFERENCE_CHECKED,
  SET_PARSE_PREFERENCE_DATA,
  SET_USER_MEMBER_PREFERENCES_V2,
  UPDATE_SELECTED_CARE_LANGUAGE,
} from './carePreferencesActions'

const initialState = fromJS({
  availableCareLanguages: undefined,
  selectedCareLanguage: undefined,
  userMemberPreferencesV2: undefined,
  isParentInitiatedInPersonS4CPreferenceChecked: true, // Parent child searches aged (0-12)
  isParentInitiatedInPersonTeenS4CPreferenceChecked: true, // Parent child searches aged (13-17)
  parsePreference: {
    data: {},
    riskLevel: null,
    id: null, // Transient ID from GenAI for free text preferences (PROVREC-5553)
  },
})

export default createReducer(initialState, {
  [SET_AVAILABLE_CARE_LANGUAGES]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('availableCareLanguages', action.data)
  },
  [UPDATE_SELECTED_CARE_LANGUAGE]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('selectedCareLanguage', action.data)
  },
  [RESET_CARE_LANGUAGE_STATE]: ($$state: any) => {
    $$state = $$state.set('availableCareLanguages', undefined)
    $$state = $$state.set('selectedCareLanguage', undefined)
    return $$state
  },
  [SET_USER_MEMBER_PREFERENCES_V2]: ($$state: any, action: any) => {
    $$state = $$state.set('userMemberPreferencesV2', action.value)
    return $$state
  },
  [SET_PARENT_INITIATED_IN_PERSON_S4C_PREFERENCE_CHECKED]: ($$state: any, action: any) => {
    $$state = $$state.set('isParentInitiatedInPersonS4CPreferenceChecked', action.value)
    return $$state
  },
  [SET_PARENT_INITIATED_IN_PERSON_TEEN_S4C_PREFERENCE_CHECKED]: ($$state: any, action: any) => {
    $$state = $$state.set('isParentInitiatedInPersonTeenS4CPreferenceChecked', action.value)
    return $$state
  },
  [SET_PARSE_PREFERENCE_DATA]: ($$state: any, action: any) => {
    $$state = $$state.setIn(['parsePreference', 'data'], fromJS(action.data))
    $$state = $$state.setIn(['parsePreference', 'id'], action.id)
    $$state = $$state.setIn(['parsePreference', 'riskLevel'], action.riskLevel)
    return $$state
  },
  [RESET_PARSE_PREFERENCE_DATA]: ($$state: any) => {
    $$state = $$state.setIn(['parsePreference', 'data'], fromJS({}))
    $$state = $$state.setIn(['parsePreference', 'id'], null)
    $$state = $$state.setIn(['parsePreference', 'riskLevel'], null)
    return $$state
  },
})
